// Identity of the signed-in user, filled by RequireAuth from the
// /api/auth/me probe it already runs. Null when the probe soft-passed
// (5xx / network blip) - consumers must render a neutral fallback, never
// fixture identity.

import { createContext, useContext } from "react";
import type { CurrentUser } from "@duralex/shared";

export const CurrentUserContext = createContext<CurrentUser | null>(null);

export function useCurrentUser(): CurrentUser | null {
  return useContext(CurrentUserContext);
}
